import { StepType, useTour } from '@reactour/tour';
import { useLocation } from 'react-router-dom';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';
import { useProvider } from 'utils/providers/Provider';

const useGetViewCreatedCompanies = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;
  const { pathname } = useLocation();

  const isInCompaniesPage = pathname.includes('companies');

  const viewCreatedCompaniesSteps: StepType[] = [
    ...(!isInCompaniesPage
      ? ([
          {
            content: 'Go to the Contacts menu tab.',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.MENU}"]`,
            position: 'right',
            action: (node: any) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(1), 200);
                },
                false,
              );
            },
          },
        ] as StepType[])
      : []),
    ...(!isInCompaniesPage
      ? ([
          {
            content: 'Then select Companies to view the Companies page.',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.SUBMENU}"]`,
            position: 'right',
            action: (node: any) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(2), 200);
                },
                false,
              );
            },
          },
        ] as StepType[])
      : []),
    {
      content: (props) => (
        <Content
          {...props}
          content="On this page you can view all your created Company contacts."
          endTour
          hideNote
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.CONTACT.COMPANY.MANAGE.TABLE}"]`,
      position: 'top',
      stepInteraction: false,
    },
  ];

  const showViewCreatedCompaniesSteps = () => {
    if (isCollapsed && !isInCompaniesPage) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(viewCreatedCompaniesSteps);
      setIsOpen(true);
    }, 300);
  };

  return showViewCreatedCompaniesSteps;
};

export default useGetViewCreatedCompanies;
